import { array, object } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const assignUnitSchema = object({
	unit: array()
		.nullable()
		.default(null)
		.min(1, validationErrMessages.approvalUnit)
		.required(validationErrMessages.approvalUnit),
	assetType: object()
		.nullable()
		.required(validationErrMessages.assetType),
	assetSubType: object()
		.nullable(),
});

export default assignUnitSchema;
